import React from "react";
// import searchWhiteIcon from "./Icon.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./OMS order list.css";
import NavBar from "../NavBar";
import { useState } from "react";
import { CSVLink } from "react-csv";
export default function OMSOrderList(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  
  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.deliveryStatus === e.target.value));
  };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Order Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Order List</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Order List</h1>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{width: '99%'}}>
          <div id="click-data">
            <p>All Orders</p>
            <p>To Confirm</p>
            <p>To Ship</p>
            <p>Shipped</p>
            <p>Completed</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by supplier ID, category"
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.id.match(val.target.value) || x.customerName.match(val.target.value)
                  )
                );
                setFiltr1("");
              }}
            />              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters">
                <option value="" selected>
                  Quantity
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
              onChange={handleFilter1}
              >
              <option selected>Order Status</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
                <option value="In progress">In Progress</option>
                <option value="Returned">Returned</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Item</th>
              <th>Delivery Date</th>
              <th>Amount</th>
              <th id='center'>Delivery Status</th>
              <th id='center'>Payment Method</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.item}</td>
                  <td>{val.deliveryDate}</td>
                  <td>{val.amount}</td>
                  <td  className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Cancelled"
                          ? "col-red"
                          : val.deliveryStatus === "In progress"
                          ? "col-yellow"
                          : val.deliveryStatus === "Returned"
                          ? "col-blue"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td id='center'>{val.paymentMethod}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.item}</td>
                  <td>{val.deliveryDate}</td>
                  <td>{val.amount}</td>
                  <td  className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Cancelled"
                          ? "col-red"
                          : val.deliveryStatus === "In progress"
                          ? "col-yellow"
                          : val.deliveryStatus  === "Returned"
                          ? "col-blue"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td id='center'>{val.paymentMethod}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export const IncomingData = [
  {id: "KCVF7777",customerName: "Donald",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF5555",customerName: "Ron",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF6666",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Returned",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Cancelled",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Returned",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Returned",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Cancelled",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Returned",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Cancelled",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Returned",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Cancelled",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Credit Card",},
  {id: "KCVF112L",customerName: "John Doe",item: `Nike men's air zoom shoe`,deliveryDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "In progress",paymentMethod: "Credit Card",},
];
